import { Box, Button, Divider, Flex, FormControl, FormLabel, HStack, IconButton, Image, Input, InputGroup, InputLeftElement, Select, SimpleGrid, Stack, Text, Textarea, useColorModeValue } from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate } from 'react-router-dom';
import { FleetType, Fleets } from '../../enums';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { FiArrowLeft } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { addFleet } from '../../store/actions';
import { fleetFormValidation } from '../../utils';
import { fleetType } from '../../types';
import { useFormik } from 'formik';

export const AddFleet = () => {

    const { is_adding_fleet, fleets_size } = useAppSelector(state => state.fleetReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const addFleetForm = useFormik({
        initialValues: {
            fleet_size: '',
            fleet_amount: 0,
            per_km: 0,
            loader_amount: 0,
            description: '',
        },
        validationSchema: fleetFormValidation,
        validateOnBlur: true,
        onSubmit: (values: fleetType) => {
            dispatch(addFleet(values)).then(() => navigate('/vehicles/fleets'));
        }
    });

    const getFleetImage = (fleet: string) => {
        switch (fleet) {
            case FleetType.BICYCLE:
                return Fleets?.BICYCLE;
            case FleetType.SCOOTER:
                return Fleets?.SCOOTER;
            case FleetType.MINI_BAKKIE:
                return Fleets?.MINI_BAKKIE;
            case FleetType.BAKKIE:
                return Fleets?.BAKKIE;
            case FleetType.HALF_TRUCK:
                return Fleets?.HALF_TRUCK;
            case FleetType.FOUR_TONS_TRUCK:
                return Fleets?.FOUR_TONS_TRUCK;
            case FleetType.EIGHT_TONS_TRUCK:
                return Fleets?.EIGHT_TONS_TRUCK;
            case FleetType.VAN:
                return Fleets?.VAN;
        }
    };

    useEffect(() => {}, []);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        <HStack align={'center'}>
                            <Stack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/vehicles/fleets' />
                            </Stack>
                            <Stack>
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Add new fleet.
                                </Text>
                            </Stack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <Stack mb={6}>
                            <SimpleGrid columns={[1, 2, 2, 3, 4]} spacing='20px' p={6} bg={'#fafafa'} borderRadius={6}>
                                {
                                    fleets_size?.map((fleet: string, index: number) => (
                                        <Stack borderColor={addFleetForm.values.fleet_size === fleet ? '#4caf50' : '#ffffff'} borderWidth={2} key={index} shadow={'md'} p={4} bg={'#FFFFFF'} borderRadius={6} onClick={() => addFleetForm.setFieldValue('fleet_size', fleet)} style={{ cursor: 'pointer' }}>
                                            <Image
                                                alignSelf={'center'}
                                                boxSize='100px'
                                                objectFit={'contain'}
                                                src={getFleetImage(fleet)}
                                                alt={fleet}
                                            />
                                            <Text textTransform={'capitalize'} textAlign={'center'}>{fleet}</Text>
                                        </Stack>
                                    ))
                                }
                            </SimpleGrid>
                        </Stack>
                        <form onSubmit={addFleetForm.handleSubmit}>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="fleet_size" isRequired mb={addFleetForm.errors.fleet_size ? 0 : 5}>
                                        <FormLabel>Fleet size</FormLabel>
                                        <Select name='fleet_size' placeholder='Select fleet size' value={addFleetForm.values.fleet_size} onChange={addFleetForm.handleChange} onBlur={addFleetForm.handleBlur}>
                                            {
                                                fleets_size?.map((fleet: string, index: number) => (<option key={index} value={fleet}>{fleet}</option>))
                                            }
                                        </Select>
                                        {addFleetForm.errors.fleet_size && <Text fontSize='sm' color='red.400'>{addFleetForm.errors.fleet_size}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="fleet_amount" isRequired mb={addFleetForm.errors.fleet_amount ? 0 : 5}>
                                        <FormLabel>Fleet amount</FormLabel>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents='none'
                                                color='gray.300'
                                                fontSize='1.2em'
                                            >
                                                R
                                            </InputLeftElement>
                                            <Input name='fleet_amount' type="text" value={addFleetForm.values.fleet_amount} onChange={addFleetForm.handleChange} onBlur={addFleetForm.handleBlur} placeholder='Enter fleet amount' />
                                        </InputGroup>
                                        {addFleetForm.errors.fleet_amount && <Text fontSize='sm' color='red.400'>{addFleetForm.errors.fleet_amount}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'50%'}>
                                    <FormControl id="per_km" isRequired mb={addFleetForm.errors.per_km ? 0 : 5}>
                                        <FormLabel>Per Km</FormLabel>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents='none'
                                                color='gray.300'
                                                fontSize='1.2em'
                                            >
                                                R
                                            </InputLeftElement>
                                            <Input name='per_km' type="text" value={addFleetForm.values.per_km} onChange={addFleetForm.handleChange} onBlur={addFleetForm.handleBlur} placeholder='Enter per km amount' />
                                        </InputGroup>
                                        {addFleetForm.errors.per_km && <Text fontSize='sm' color='red.400'>{addFleetForm.errors.per_km}</Text>}
                                    </FormControl>
                                </Box>
                                <Box minW={'50%'}>
                                    <FormControl id="loader_amount" isRequired mb={addFleetForm.errors.loader_amount ? 0 : 5}>
                                        <FormLabel>Loader amount</FormLabel>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents='none'
                                                color='gray.300'
                                                fontSize='1.2em'
                                            >
                                                R
                                            </InputLeftElement>
                                            <Input name='loader_amount' type="text" value={addFleetForm.values.loader_amount} onChange={addFleetForm.handleChange} onBlur={addFleetForm.handleBlur} placeholder='Enter loader amount' />
                                        </InputGroup>
                                        {addFleetForm.errors.loader_amount && <Text fontSize='sm' color='red.400'>{addFleetForm.errors.loader_amount}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box minW={'100%'}>
                                    <FormControl id="description" isRequired mb={addFleetForm.errors.description ? 0 : 5}>
                                        <FormLabel>Description</FormLabel>
                                        <Textarea name='description' noOfLines={3} value={addFleetForm.values.description} onChange={addFleetForm.handleChange} onBlur={addFleetForm.handleBlur} placeholder='Enter description' />
                                        {addFleetForm.errors.description && <Text fontSize='sm' color='red.400'>{addFleetForm.errors.description}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <Stack spacing={10} mt={3}>
                                <Button
                                    type='submit'
                                    size="lg"
                                    colorScheme={'yellow'}
                                    isDisabled={is_adding_fleet || !addFleetForm.isValid}
                                    isLoading={is_adding_fleet}
                                    >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};